import React, {useEffect} from 'react'
import Box from "@mui/material/Box";

import './CRM.scss'

import {useMediaQuery} from "react-responsive";
import {Outlet} from "react-router-dom";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {CRMTableTabs} from "./ClientsPage/CRMTableTabs";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {useDebounce} from "@uidotdev/usehooks";
import {useLeadsStore} from "../../stores/leadsStore";
import {useShallow} from "zustand/react/shallow";
import {useClientsStore} from "../../stores/clientsStore";
import {useCRMStore} from "../../stores/crmStore";


export const CRMPage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const { search, currentYear, currentMonth } = useCRMStore(
        useShallow((state) => ({
            currentYear: state.currentYear,
            currentMonth: state.currentMonth,
            search: state.search,
        }))
    )

    const {
        currentLeadsPage,
        fetchListLeads,
    } = useLeadsStore(
        useShallow((state) => ({
            fetchListLeads: state.fetchListLeads,
            currentLeadsPage: state.current_page,
        }))
    )

    const {
        currentClientsPage,
        fetchListClients,
    } = useClientsStore(
        useShallow((state) => ({
            fetchListClients: state.fetchListClients,
            currentClientsPage: state.current_page,
        }))
    )
    const debouncedSearch = useDebounce(search, 300)

    const buildParams = (search, current_page) => {
        let queryParams = new URLSearchParams({
            month: currentMonth,
            year: currentYear
        })

        if (typeof current_page === 'number' && current_page !== 0) {
            queryParams.append("page", current_page + 1)
        }

        if (search.length) {
            queryParams.append("s", search)
        }
        return queryParams
    }

    // Leads
    useEffect(function fetchListLeadsFromBackendOnMount(){
        fetchListLeads(buildParams(search, currentLeadsPage))
    }, [])


    useDidMountEffect(function fetchListLeadsOnMonthOrYearOrSearchChange(){
        fetchListLeads(buildParams(search))
    }, [currentMonth, currentYear, debouncedSearch])

    // Clients
    useEffect(function fetchListClientsFromBackendOnMount(){
        fetchListClients(buildParams(search, currentClientsPage))
    }, [])

    useDidMountEffect(function fetchListClientsOnMonthOrYearOrSearchChange(){
        fetchListClients(buildParams(search))
    }, [currentMonth, currentYear, debouncedSearch])

    return (
        <React.Fragment>
            <Box
                id={"CRMPage"}
                style={{
                    display: isTabletOrMobile ? '' : 'flex',
                    height: '100vh',
                    overflow: isTabletOrMobile ? 'auto' : 'hidden',
                    flexDirection: 'column',
                    padding: isTabletOrMobile ? '30px' : '60px 30px',
                }}
            >
                <Outlet/>
                <CRMTableTabs/>
            </Box>
        </React.Fragment>
    )
}